import Button from '@rio-cloud/rio-uikit/Button';
import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';

import { TrackingAction, TrackingCategory, trackingAttributes } from '../../../../configuration/setup/googleTagManager';
import type { State } from '../../../../reducers';
import { getIsCurrentValuesDisplayed, realtimeActions } from '../../redux/realtime.redux';
import type { ModeSwitchButtonDispatchProps, ModeSwitchButtonProps, ModeSwitchButtonStateProps } from '../types';

const trackClickShowCurrentValues = trackingAttributes(
    TrackingCategory.DRIVING_TIMES_VIEW,
    TrackingAction.CHANGE_TIME_DISPLAY_MODE,
    'display current times'
);

const trackClickShowRemainingValues = trackingAttributes(
    TrackingCategory.DRIVING_TIMES_VIEW,
    TrackingAction.CHANGE_TIME_DISPLAY_MODE,
    'display remaining times'
);

export const ModeSwitchButtons = (props: ModeSwitchButtonProps): JSX.Element => {
    const { isShowCurrentValues, showCurrentValues, showRemainingValues } = props;

    return (
        <div className={'btn-group'}>
            <Button
                key={'RealTime-drivingTimes-Button'}
                active={isShowCurrentValues}
                onClick={showCurrentValues}
                {...trackClickShowCurrentValues}
            >
                <FormattedMessage id={'intl-msg:timed.driving-time-table.ongoing'} />
            </Button>
            <Button
                key={'RealTime-remainingTimes-Button'}
                active={!isShowCurrentValues}
                onClick={showRemainingValues}
                {...trackClickShowRemainingValues}
            >
                <FormattedMessage id={'intl-msg:timed.common.remaining'} />
            </Button>
        </div>
    );
};

const mapStateToProps = (state: State): ModeSwitchButtonStateProps => ({
    isShowCurrentValues: getIsCurrentValuesDisplayed(state),
});

const mapDispatchToProps = (dispatch: Dispatch): ModeSwitchButtonDispatchProps => ({
    showCurrentValues: (): void => {
        dispatch(realtimeActions.setIsCurrentValuesDisplayed(true));
    },
    showRemainingValues: (): void => {
        dispatch(realtimeActions.setIsCurrentValuesDisplayed(false));
    },
});

export const ModeSwitchButtonsContainer = connect(mapStateToProps, mapDispatchToProps)(ModeSwitchButtons);
